import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { beforeAfterSlides } from '../../data/beforeAfter';
export function BeforeAfterCarousel() {
  const [[index, direction], setState] = useState<[number, number]>([0, 0]);
  const reduceMotion = useReducedMotion();
  const total = beforeAfterSlides.length;
  const slide = beforeAfterSlides[index];
  const [paused, setPaused] = useState(false);
  const paginate = (dir: number) => setState(([i]) => [(i + dir + total) % total, dir]);
  const goTo = (i: number) => setState(([cur]) => [i, i > cur ? 1 : -1]);
  useEffect(() => {
    if (paused || reduceMotion) return;
    const id = window.setInterval(() => paginate(1), 3500);
    return () => window.clearInterval(id);
  }, [paused, reduceMotion, index]);
  const offset = reduceMotion ? 0 : 40;
  return <div className="w-full" role="region" aria-roledescription="carousel" aria-label="Before and after transformations" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} onFocus={() => setPaused(true)} onBlur={() => setPaused(false)} data-id="element-18" data-mp="2sgi5ov78j9v4">
      <div className="relative aspect-square w-full overflow-hidden rounded-[4px] bg-sand" data-id="element-19" data-mp="1lsu5jlo1v3jk">
        <AnimatePresence initial={false} custom={direction} mode="popLayout" data-id="element-20" data-mp="1gusqdbtqvodd">
          <motion.img key={slide.src} src={slide.src} alt={slide.alt} custom={direction} initial={{
          opacity: 0,
          x: direction * offset
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: direction * -offset
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} drag="x" dragConstraints={{
          left: 0,
          right: 0
        }} dragElastic={0.2} onDragEnd={(_, info) => {
          if (info.offset.x < -60) paginate(1);else if (info.offset.x > 60) paginate(-1);
        }} className="absolute inset-0 h-full w-full cursor-grab select-none object-cover active:cursor-grabbing" draggable={false} data-id="element-21" data-mp="2digvmt8pjmfi" />
        </AnimatePresence>

        <button type="button" onClick={() => paginate(-1)} aria-label="Previous transformation" className="absolute left-3 top-1/2 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-cream/90 text-ink shadow-sm transition-[background-color,transform] duration-150 ease-out hover:bg-cream active:scale-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-22" data-mp="gk9jha2nlwm7">
          <ChevronLeftIcon className="h-5 w-5" aria-hidden data-id="element-23" data-mp="1w4x9w4e72yo" />
        </button>
        <button type="button" onClick={() => paginate(1)} aria-label="Next transformation" className="absolute right-3 top-1/2 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-cream/90 text-ink shadow-sm transition-[background-color,transform] duration-150 ease-out hover:bg-cream active:scale-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-24" data-mp="1wespz87i2br">
          <ChevronRightIcon className="h-5 w-5" aria-hidden data-id="element-25" data-mp="3fdrzkfmcwuir" />
        </button>
      </div>

      <div className="mt-5 flex items-center justify-between" data-id="element-26" data-mp="3aefdhx3b7rh8">
        <p className="text-sm font-semibold text-body" aria-live="polite" data-id="element-27" data-mp="3acujq9otkckf">
          {index + 1} / {total}
        </p>
        <div className="flex flex-wrap justify-end gap-1.5" data-id="element-28" data-mp="3obkgtpbn2c8s">
          {beforeAfterSlides.map((s, i) => <button key={s.src} type="button" onClick={() => goTo(i)} aria-label={`Show transformation ${i + 1}`} aria-current={i === index} className={`h-2 rounded-full transition-[width,background-color] duration-200 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-gold ${i === index ? 'w-7 bg-gold' : 'w-2 bg-ink/20 hover:bg-ink/40'}`} data-id="element-29" data-mp="1ycfkj201h63" data-mpi={i} />)}
        </div>
      </div>
    </div>;
}